import {
	useStripe,
	useElements,
	PaymentElement,
} from '@stripe/react-stripe-js';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Button } from '@material-ui/core';
import './BadgeCheckoutForm.scss';

const STRIPE_PRICE_CHF = 10;

const BadgeCheckoutForm = ({ onSuccess, onError, afterSubmit, errorMsg }) => {
	const stripe = useStripe();
	const elements = useElements();
	const [submitting, setSubmitting] = useState(false);
	const [billingDetails, setBillingDetails] = useState({
		name: '',
		email: '',
		address: {
			line1: '',
			line2: '',
			city: '',
			state: '',
			postal_code: '',
			//country: 'CH',
		},
	});

	const translation = useSelector(
		(state) => state.languages.translations[state.languages.platformLanguage]
	);

	const handleSubmit = async () => {
		if (!stripe || !elements) return;
		setSubmitting(true);
		try {
			const { error, paymentIntent } = await stripe.confirmPayment({
				elements,
				confirmParams: {
					payment_method_data: {
						billing_details: billingDetails,
					},
				},
				redirect: 'if_required',
			});

			if (error) {
				onError(error.message || 'Payment failed. Please try again.');
			} else if (paymentIntent && paymentIntent.status === 'succeeded') {
				onSuccess(paymentIntent);
			} else {
				onError('Payment was not completed. Please try again.');
			}
		} catch (e) {
			onError(e?.message || 'Payment error. Please try again.');
		} finally {
			setSubmitting(false);
			afterSubmit?.();
		}
	};

	return (
		<div className="badge-checkout-form">
			<div className="badge-payment-element">
				<PaymentElement options={{ layout: 'tabs' }} />
			</div>

			<Box mt={2}>
				<Typography
					variant="subtitle2"
					gutterBottom
					align="left"
					className="billing-address-title"
				>
					{translation?.auditorium?.claimYourBadgeDialogBillingAddress}
				</Typography>

				<Box mb={2}>
					<input
						type="text"
						value={billingDetails.name}
						onChange={(e) =>
							setBillingDetails((prev) => ({ ...prev, name: e.target.value }))
						}
						placeholder={
							translation?.auditorium?.claimYourBadgeDialogBillingFullName
						}
						className="billing-input"
						required
					/>
				</Box>

				<Box mb={2}>
					<input
						type="email"
						value={billingDetails.email}
						onChange={(e) =>
							setBillingDetails((prev) => ({ ...prev, email: e.target.value }))
						}
						placeholder={
							translation?.auditorium?.claimYourBadgeDialogBillingEmail
						}
						className="billing-input"
						required
					/>
				</Box>

				<Box mb={2}>
					{/* <Typography variant="body2" gutterBottom>
						Address Line 1 *
					</Typography> */}
					<input
						type="text"
						value={billingDetails.address.line1}
						onChange={(e) =>
							setBillingDetails((prev) => ({
								...prev,
								address: { ...prev.address, line1: e.target.value },
							}))
						}
						placeholder={
							translation?.auditorium?.claimYourBadgeDialogBillingAddressLine1
						}
						className="billing-input"
						required
					/>
				</Box>

				<Box display="flex" gap={4} mb={2}>
					<Box flex={1} mr={1}>
						<input
							type="text"
							value={billingDetails.address.city}
							onChange={(e) =>
								setBillingDetails((prev) => ({
									...prev,
									address: { ...prev.address, city: e.target.value },
								}))
							}
							placeholder={
								translation?.auditorium?.claimYourBadgeDialogBillingCity
							}
							className="billing-input"
							required
						/>
					</Box>
					<Box flex={1}>
						{/* <Typography variant="body2" gutterBottom>
							Postal Code *
						</Typography> */}
						<input
							type="text"
							value={billingDetails.address.postal_code}
							onChange={(e) =>
								setBillingDetails((prev) => ({
									...prev,
									address: { ...prev.address, postal_code: e.target.value },
								}))
							}
							placeholder={
								translation?.auditorium?.claimYourBadgeDialogBillingPostalCode
							}
							className="billing-input"
							required
						/>
					</Box>
				</Box>
				<Box>
					{errorMsg && (
						<Typography className="error-text" color="error">
							{errorMsg}
						</Typography>
					)}
				</Box>
			</Box>

			<Box mt={errorMsg ? 0 : 2} display="flex" justifyContent="center">
				<Button
					className="action-btn"
					onClick={handleSubmit}
					disabled={
						!stripe ||
						submitting ||
						!billingDetails.name ||
						!billingDetails.email ||
						!billingDetails.address.line1 ||
						!billingDetails.address.city ||
						!billingDetails.address.postal_code
					}
				>
					{submitting
						? translation?.auditorium?.claimYourBadgeDialogPaymentProcessing
						: `${translation?.auditorium?.claimYourBadgeDialogPaymentButton} CHF${STRIPE_PRICE_CHF}`}
				</Button>
			</Box>
		</div>
	);
};

export default BadgeCheckoutForm;
